import FetchCall from '../../../shared/local_fetch_call'
const namespaced = true

const state = {
  sections: [],
  section: 'none',
  number: 1,
  paymentFields: {},
  hotelInCart: true,
  topDiv: null,
  billing: {
    address1: '',
    address2: '',
    city: '',
    companyName: '',
    corporate: false,
    country: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    purchaseOrderNumber: '',
    state: '',
    zipCode: ''
  }
}

const mutations = {
  updatePaymentFields(state, newFields) {
    const pf = state.paymentFields
    state.paymentFields = Object.assign({}, pf, newFields)
  },
  updateHotelInCart(state, hotelInCart) {
    state.hotelInCart = hotelInCart
  },
  updateSection(state, section) {
    if (state.section == 'address') {
      saveBillingToOrder(state.billing)
    } else if (state.section == 'hotel' && state.paymentFields.roomInformation.length > 0) {
      updateHotelReservationInfo(state.paymentFields.roomInformation)
    }

    if (state.section == section) {
      state.section = 'none'
    } else {
      if (state.topDiv) {
        state.topDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
      state.section = section
    }
  },
  updateSectionNumber(state, numberOfAddOns) {
    if (numberOfAddOns > 0) {
      state.number = 0
    } else {
      state.number = 1
    }
  },
  setTopDiv(state, div) {
    state.topDiv = div
  },
  updateFirstName(state, firstName) {
    state.billing.firstName = firstName
  },
  updateAddress1(state, address1) {
    state.billing.address1 = address1
  },
  updateAddress2(state, address2) {
    state.billing.address2 = address2
  },
  updateCity(state, city) {
    state.billing.city = city
  },
  updateCompanyName(state, name) {
    state.billing.companyName = name
  },
  updateCorporate(state, value) {
    state.billing.corporate = value
  },
  updateCountry(state, country) {
    state.billing.country = country
  },
  updateLastName(state, lastName) {
    state.billing.lastName = lastName
  },
  updatePhoneNumber(state, phoneNumber) {
    state.billing.phoneNumber = phoneNumber
  },
  updatePurchaseOrderNumber(state, pon) {
    state.billing.purchaseOrderNumber = pon
  },
  updateState(state, stateName) {
    state.billing.state = stateName
  },
  updateZipCode(state, zipCode) {
    state.billing.zipCode = zipCode
  }
}

const actions = {

}

const getters = {

}

const saveBillingToOrder = (billing) => {
  let body = JSON.stringify({
    order: {
      first_name: billing.firstName,
      last_name: billing.lastName,
      corporate_group: billing.corporate,
      phone: billing.phoneNumber,
      street_1: billing.address1,
      street_2: billing.address2,
      state: billing.state,
      country: billing.country,
      zip_code: billing.zipCode,
      company_name: billing.companyName,
      purchase_order_number: billing.purchaseOrderNumber
    }
  })
  FetchCall.fetchWithoutLocale(
    '/cart',
    'PUT',
    body
  )
}

const updateHotelReservationInfo = async (roomInformation) => {
  roomInformation.forEach(async info => {
    let body = JSON.stringify({
      hotel_reservations: {
        name: info.name,
        number_of_adults: info.numberOfAdults
      }
    })
    await FetchCall.fetchWithoutLocale(
      `/api/checkout_hotel_reservations/${info.id}`,
      'PUT',
      body
    )
  })
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
